<template>
    <div>
        <v-overlay :model-value="loading"
                   class="align-center justify-center">
            <v-progress-circular color="primary"
                                 indeterminate
                                 size="64"></v-progress-circular>
        </v-overlay>
        <div v-if="monthlyData || weeklyData">
            <v-expansion-panels v-model="panel">
                <v-expansion-panel>
                    <v-expansion-panel-title>
                        <div class="d-flex justify-space-between align-center w-100">
                            <h2 v-if="monthlyData">By Month <small class="text-muted">Ending {{ monthlyData.currentPeriodEndDate }}</small></h2>
                            <v-btn-group variant="outlined" divided density="comfortable">
                                <v-btn prepend-icon="mdi-chevron-left" @click.stop="loadMonthlyPeriod('previous')">Previous Period</v-btn>
                                <v-btn @click.stop="loadMonthlyPeriod('current')">Current Period</v-btn>
                                <v-btn append-icon="mdi-chevron-right" @click.stop="loadMonthlyPeriod('next')">Next Period</v-btn>
                            </v-btn-group>
                        </div>
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                        <div v-if="monthlyData">
                            <v-table class="contact-sum-table">
                                <thead>
                                    <tr>
                                        <th class="w-10">Customers</th>
                                        <th v-for="month in monthlyData.months" :key="month" style="width:6.3%" class="number-cell">{{ month }}</th>
                                        <th class="number-cell" style="width:8%;">Total</th>
                                        <th class="number-cell" style="width:6.3%">Average</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="totals-row">
                                        <td>Total</td>
                                        <td v-for="(monthData, index) in monthlyTotalsData" :key="index" class="number-cell">
                                            <span v-if="monthData && monthData != 0">{{ numberWithCommas(monthData, 0)  }}</span>
                                        </td>
                                        <td class="number-cell">
                                            <span v-if="monthlyTotal">{{ numberWithCommas(monthlyTotal, 0)  }}</span>
                                        </td>
                                        <td class="number-cell">
                                            <span v-if="monthlyAverage">{{ numberWithCommas(monthlyAverage, 0)  }}</span>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="nuwallContactMonthly">
                                    <tr class="nuwall-row">
                                        <td><contact-link :contact="nuwallContactMonthly"></contact-link></td>
                                        <td v-for="(monthData, index) in nuwallContactMonthly.receievedDataMonth" :key="index" class="number-cell" :class="{'highlight-row':(monthData && monthData > nuwallContactMonthly.monthlyAverageSpend)}">
                                            <span v-if="monthData && monthData != 0">{{ numberWithCommas(monthData, 0)  }}</span>
                                        </td>
                                        <td class="number-cell">
                                            <strong>{{ numberWithCommas(nuwallContactMonthly.monthlyTotal, 0) }}</strong>
                                        </td>
                                        <td class="number-cell">
                                            <strong>{{ numberWithCommas(nuwallContactMonthly.monthlyAverageSpend, 0) }}</strong>
                                        </td>
                                    </tr>
                                    <tr class="percentage-row">
                                        <td>Nu-Wall %</td>
                                        <td v-for="(monthData, index) in nuwallContactMonthly.receievedDataMonth" :key="index" class="number-cell">
                                            <span v-if="monthData && monthData != 0 && monthlyTotalsData[index] != 0">{{ numberWithCommas((monthData/monthlyTotalsData[index]*100), 1)  }}%</span>
                                        </td>
                                        <td class="number-cell"></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                                <tbody>
                                    <tr v-for="row in nonNuwallContactMonthly" :key="row.name">
                                        <td>
                                            <contact-link :contact="row"></contact-link>
                                        </td>
                                        <td v-for="(monthData, index) in row.receievedDataMonth" :key="index" class="number-cell" :class="{'highlight-row':(monthData && monthData > row.monthlyAverageSpend)}">
                                            <span v-if="monthData && monthData != 0">{{ numberWithCommas(monthData, 0)  }}</span>
                                        </td>
                                        <td class="number-cell">
                                            <strong>{{ numberWithCommas(row.monthlyTotal, 0) }}</strong>
                                        </td>
                                        <td class="number-cell">
                                            <strong>{{ numberWithCommas(row.monthlyAverageSpend, 0) }}</strong>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-table>
                        </div>
                    </v-expansion-panel-text>
                </v-expansion-panel>
                <v-expansion-panel>
                    <v-expansion-panel-title>
                        <div class="d-flex justify-space-between align-center w-100">
                            <h2 v-if="weeklyData">By Week <small class="text-muted">Ending {{ weeklyData.currentPeriodEndDate }}</small></h2>
                            <v-btn-group variant="outlined" divided density="comfortable">
                                <v-btn prepend-icon="mdi-chevron-left" @click.stop="loadWeeklyPeriod('previous')">Previous Period</v-btn>
                                <v-btn @click.stop="loadWeeklyPeriod('current')">Current Period</v-btn>
                                <v-btn append-icon="mdi-chevron-right" @click.stop="loadWeeklyPeriod('next')">Next Period</v-btn>
                            </v-btn-group>
                        </div>
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                        <div v-if="weeklyData">
                            <v-table class="contact-sum-table">
                                <thead>
                                    <tr>
                                        <th class="w-10">Customers</th>
                                        <th v-for="week in weeklyData.weeks" :key="week" style="width:5.46%" class="number-cell">{{ week }}</th>
                                        <th class="number-cell" style="width:8%;">Total</th>
                                        <th class="number-cell" style="width:5.46%">Average</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="totals-row">
                                        <td>Total</td>
                                        <td v-for="(weekData, index) in weeklyTotalsData" :key="index" class="number-cell">
                                            <span v-if="weekData && weekData != 0">{{ numberWithCommas(weekData, 0)  }}</span>
                                        </td>
                                        <td class="number-cell">
                                            <span v-if="weeklyTotal">{{ numberWithCommas(weeklyTotal, 0)  }}</span>
                                        </td>
                                        <td class="number-cell">
                                            <span v-if="weeklyAverage">{{ numberWithCommas(weeklyAverage, 0)  }}</span>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="nuwallContactWeekly">
                                    <tr class="nuwall-row">
                                        <td><contact-link :contact="nuwallContactWeekly"></contact-link></td>
                                        <td v-for="(weekData, index) in nuwallContactWeekly.receievedDataWeekly" :key="index" class="number-cell" :class="{'highlight-row':(weekData && weekData > nuwallContactWeekly.weeklyAverageSpend)}">
                                            <span v-if="weekData && weekData != 0">{{ numberWithCommas(weekData, 0)  }}</span>
                                        </td>
                                        <td class="number-cell">
                                            <strong>{{ numberWithCommas(nuwallContactWeekly.weeklyTotal, 0) }}</strong>
                                        </td>
                                        <td class="number-cell">
                                            <strong>{{ numberWithCommas(nuwallContactWeekly.weeklyAverageSpend, 0) }}</strong>
                                        </td>
                                    </tr>
                                    <tr class="percentage-row">
                                        <td>Nu-Wall %</td>
                                        <td v-for="(weekData, index) in nuwallContactWeekly.receievedDataWeekly" :key="index" class="number-cell">
                                            <span v-if="weekData && weekData != 0 && weeklyTotalsData[index] != 0">{{ numberWithCommas((weekData/weeklyTotalsData[index]*100), 1)  }}%</span>
                                        </td>
                                        <td class="number-cell"></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                                <tbody>
                                    <tr v-for="row in nonNuwallContactWeekly" :key="row.name">
                                        <td>
                                            <contact-link :contact="row"></contact-link>
                                        </td>
                                        <td v-for="(weekData, index) in row.receievedDataWeekly" :key="index" class="number-cell" :class="{'highlight-row':(weekData && weekData > row.weeklyAverageSpend)}">
                                            <span v-if="weekData && weekData != 0">{{ numberWithCommas(weekData, 0)  }}</span>
                                        </td>
                                        <td class="number-cell">
                                            <strong>{{ numberWithCommas(row.weeklyTotal, 0) }}</strong>
                                        </td>
                                        <td class="number-cell">
                                            <strong>{{ numberWithCommas(row.weeklyAverageSpend, 0) }}</strong>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-table>
                        </div>
                    </v-expansion-panel-text>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
    </div>
</template>
<style scoped>
    .number-cell {
        text-align: right !important;
    }

    .totals-row td {
        background-color: aliceblue;
        font-weight: bold;
    }

    .percentage-row td {
        background-color: #FFF3E0;
        font-weight: bold;
    }

    .highlight-row {
        background-color: #F1F8E9;
    }

    .nuwall-row td {
        border-top: 2px solid #ccc;
    }
</style>
<script>
    import { numberWithCommas } from "../../mixins/numberMixins";
    function initialState() {
        return {
            loading: false,
            saving: false,
            monthlyData: null,
            weeklyData: null,
            currentMonthlyEndDate: null,
            currentWeeklyEndDate: null,
            panel: [0]
        };
    }
    export default {
        name: "ReceivedDetailReport",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.loadMonthlyReport();
            this.loadWeeklyReport();
        },
        props: {
            definition: Object
        },
        methods: {
            loadMonthlyReport(endDate = null) {
                this.loading = true;
                let url = `${this.definition.route}?type=0`;
                if (endDate) {
                    url += `&endDate=${endDate}`;
                }

                this.$api.get(url)
                    .then(res => {
                        this.loading = false;
                        this.monthlyData = res.data;
                        this.currentMonthlyEndDate = res.data.currentPeriodEndDate;
                    }).catch(error => {
                        this.loading = false;
                        console.error('Error loading monthly data:', error);
                    });
            },
            loadWeeklyReport(endDate = null) {
                this.loading = true;
                let url = `${this.definition.route}?type=1`;
                if (endDate) {
                    url += `&endDate=${endDate}`;
                }

                this.$api.get(url)
                    .then(res => {
                        this.loading = false;
                        this.weeklyData = res.data;
                        this.currentWeeklyEndDate = res.data.currentPeriodEndDate;
                    }).catch(error => {
                        this.loading = false;
                        console.error('Error loading weekly data:', error);
                    });
            },
            loadMonthlyPeriod(direction) {
                let endDate = null;
                if (direction === 'previous' && this.monthlyData?.previousPeriodEndDate) {
                    endDate = this.monthlyData.previousPeriodEndDate;
                } else if (direction === 'next' && this.monthlyData?.nextPeriodEndDate) {
                    endDate = this.monthlyData.nextPeriodEndDate;
                }
                this.loadMonthlyReport(endDate);
            },
            loadWeeklyPeriod(direction) {
                let endDate = null;
                if (direction === 'previous' && this.weeklyData?.previousPeriodEndDate) {
                    endDate = this.weeklyData.previousPeriodEndDate;
                } else if (direction === 'next' && this.weeklyData?.nextPeriodEndDate) {
                    endDate = this.weeklyData.nextPeriodEndDate;
                }
                this.loadWeeklyReport(endDate);
            },
            numberWithCommas,
        },
        computed: {
            nonNuwallContactWeekly() {
                if (!this.weeklyData) return [];
                return this.weeklyData.contactData.filter(contact => {
                    return !contact.isNuwall && contact.weeklyTotal > 300;
                }).sort((a, b) => b.weeklyTotal - a.weeklyTotal);
            },
            nonNuwallContactMonthly() {
                if (!this.monthlyData) return [];
                return this.monthlyData.contactData.filter(contact => {
                    return !contact.isNuwall && contact.monthlyTotal > 1200;
                }).sort((a, b) => b.monthlyTotal - a.monthlyTotal);
            },
            nuwallContactWeekly() {
                if (!this.weeklyData) return null;
                return this.weeklyData.contactData.find(contact => {
                    return contact.isNuwall;
                });
            },
            nuwallContactMonthly() {
                if (!this.monthlyData) return null;
                return this.monthlyData.contactData.find(contact => {
                    return contact.isNuwall;
                });
            },
            weeklyTotal() {
                if (this.weeklyTotalsData) {
                    return this.weeklyTotalsData.reduce((acc, obj) => acc + obj, 0);
                }
                return 0;
            },
            weeklyAverage() {
                if (this.weeklyTotal && this.weeklyTotalsData.length > 0) {
                    return this.weeklyTotal / this.weeklyTotalsData.length;
                }
                return 0;
            },
            monthlyTotal() {
                if (this.monthlyTotalsData) {
                    return this.monthlyTotalsData.reduce((acc, obj) => acc + obj, 0);
                }
                return 0;
            },
            monthlyAverage() {
                if (this.monthlyTotal && this.monthlyTotalsData.length > 0) {
                    return this.monthlyTotal / this.monthlyTotalsData.length;
                }
                return 0;
            },
            weeklyTotalsData() {
                if (!this.weeklyData) return [];
                return this.weeklyData.weeks.map((week, index) => {
                    let total = 0;
                    this.weeklyData.contactData.forEach(row => {
                        total += row.receievedDataWeekly[index];
                    });
                    return total;
                });
            },
            monthlyTotalsData() {
                if (!this.monthlyData) return [];
                return this.monthlyData.months.map((month, index) => {
                    let total = 0;
                    this.monthlyData.contactData.forEach(row => {
                        total += row.receievedDataMonth[index];
                    });
                    return total;
                });
            },
        }
    };
</script>